export const PAGINATOR_DEFAULT_PAGE_SIZE = 10;

export const PAGINATOR_PAGE_SIZES = [5, 10, 20, 50, 100];
export const BID_OPENING_PING_INTERVAL = 5000;
export const COUNTDOWN_GET_STATUS_MILLISECONDS = 500000000;
export const CKEDITOR_DEFAULT_TOOLBAR = [
    'heading', '|',
    'bold', 'italic', 'underline', 'strikethrough', '|', 'highlight', '|',
    'fontFamily', 'fontSize', '|',
    'numberedList', 'bulletedList', '|',
    'link',
    'blockquote', '|',
    'insertTable', 'tableRow', 'tableColumn'
];

export const PUBLIC_CONTEXT = {
    tender_revision_ids: [],
    context_operation: [
        {
            username: 'public',
            identifier: 'covid19-dashboard',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-area-visit',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-area-visit',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-bid-arrangement-and-submit',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-bid-arrangement-and-submit',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-bid-evaluation',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-bid-evaluation',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-bidding-amendment',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-bidding-amendment',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-bidding-and-procurement-notice',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-bidding-and-procurement-notice',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-bidding-bid',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-bidding-bid',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-contract',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-contract-award-notice',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-contract-award-notice',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-contract-negotiations',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-contract-negotiations',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-debarment',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-debarment',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-extend-bid-validity',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-extend-bid-validity',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-extended-evaluation-period',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-extended-evaluation-period',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-list-of-procurement-opportunities',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-list-of-procurement-opportunities',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-miscellaneous-procurement-process-report',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-miscellaneous-procurement-process-report',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-objections-and-administrative-review',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-objections-and-administrative-review',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-pre-bid-meeting',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-pre-bid-meeting',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-procurement-management-team-remarks',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-public-remark',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-public-remark',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-public-remarks',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-public-remarks',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-resumption-of-the-procurement-process',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-resumption-of-the-procurement-process',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-termination-of-procurement-process',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-termination-of-procurement-process',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-tracking-procurement-process',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-tracking-procurement-process',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'resource_allocations',
            type: 'resource_allocation',
            values: []
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-initiation',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-initiation',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-preparation',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-preparation',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-bid-opening',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-bid-opening',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-award-decision-notice',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-award-decision-notice',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-contract-signing',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-contract-signing',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-expression-of-interest',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-expression-of-interest',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-consultants-shortlist-report',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-consultants-shortlist-report',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-request-for-proposal',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-request-for-proposal',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-technical-proposals-opening',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-technical-proposals-opening',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-financial-proposals-opening',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-financial-proposals-opening',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-technical-proposals-evaluation',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-technical-proposals-evaluation',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-financial-proposal-evaluation-negotiation',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-financial-proposal-evaluation-negotiation',
            type: 'context_operation',
            values: ['view']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-consultancy-award-decision-notice',
            type: 'context_operation',
            values: ['enter']
        },
        {
            username: 'public',
            identifier: 'aets-non-electronic-consultancy-award-decision-notice',
            type: 'context_operation',
            values: ['view']
        }
    ]
};
